import React, { useEffect, useState } from 'react';
export const AnimatedNumber = ({ targetNumber, currentNumber, duration, decimals = 0, delay = 0, paused, disableAnimation })=>{
    const [displayValue, setDisplayValue] = useState(disableAnimation ? targetNumber : currentNumber);
    useEffect(()=>{
        if (!paused && !disableAnimation) {
            let animationFrame;
            const startTime = performance.now() + delay;
            const startValue = currentNumber;
            const animate = (time)=>{
                const elapsed = time - startTime;
                if (elapsed < 0) {
                    animationFrame = requestAnimationFrame(animate);
                    return;
                }
                const progress = Math.min(elapsed / duration, 1);
                const value = startValue + (targetNumber - startValue) * progress;
                setDisplayValue(value);
                if (progress < 1) {
                    animationFrame = requestAnimationFrame(animate);
                }
            };
            animationFrame = requestAnimationFrame(animate);
            return ()=>cancelAnimationFrame(animationFrame);
        }
        return ()=>null;
    }, [
        currentNumber,
        targetNumber,
        duration,
        delay,
        paused,
        disableAnimation
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, displayValue.toFixed(decimals));
};
